import { gql } from "graphql-request";

export const AdjustmentLineFieldsFragment = gql`
  fragment AdjustmentLineFieldsFragment on AdjustmentLineSearchResult {
    subdomain
    budgetId
    budgetName
    proposalId
    proposalName
    worksheetId
    worksheetName
    ledgerType
    hasLinkedWorkforce
    displayAccountString
  }
`;
